import { render, staticRenderFns } from "./CartaoTabelaBase.vue?vue&type=template&id=916e0d14&scoped=true"
import script from "./CartaoTabelaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoTabelaBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916e0d14",
  null
  
)

export default component.exports